@if (glossarys) {
  <section id="glossary-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>Glossary</h1>
        </div>
      </div>
    </div>
  </section>
}

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="block glossary">
          <ul>
            @for (a of alphabeticalLinks; track a) {
              <li><a [routerLink]="['/glossary']" fragment="{{a.anchor}}"
              [ngClass]="{'empty': a.disabled}">{{a.letter}}</a></li>
            }
          </ul>
        </div>
      </div>
    </div>

    @for (g of glossarys; track g) {
      <div class="row glossaryRow" id={{g.anchor_alphabetical?g.anchor_alphabetical:g.id}}>
        <div class="col-sm-3">
          <a class="anchor" [routerLink]='"."' [fragment]="g.anchor" id="{{g.anchor}}" name="{{g.anchor}}">{{g.term}}</a>
        </div>
        <div class="col-sm-9">
          {{g.definition}}
        </div>
      </div>
    }
  </div>

</section>